import { z } from 'zod';
export const attachmentTypeCreateSchema = z.object({
    name: z.string().min(1, 'Name is required').max(255),
    description: z.string().min(1, 'Description is required').nullable(),
    isActive: z.boolean(),
});
